import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { FC } from "react";
import type { NoteStatus, NoteTypes } from "@/services/api/entities/note/types";
import { getNoteStatusText, noteDateFormat } from "../../lib";
import styles from "./styles.module.scss";

interface Props {
  date: string;
  dueDate: string;
  isShowFooter?: boolean;
  status: NoteStatus;
  statusColor: string;
  noteType: NoteTypes;
}

export const NotesListCardFooter: FC<Props> = ({
  date,
  dueDate,
  status,
  statusColor,
  noteType,
}) => {
  const { t } = useTranslation();

  const statusText = getNoteStatusText(status);
  const formattedDate = noteDateFormat(date);
  const formattedDueDate = noteDateFormat(dueDate);
  return (
    <div className={styles.footer}>
      <div className={styles.date}>{formattedDate}</div>
      {noteType === "DEFAULT_COMMITMENT" && (
        <div className={classNames(styles[statusText.color], styles[statusColor])}>
          {statusText?.dueText}
          {status?.length && status !== "DONE" && dueDate !== "" && (
            <>
              {" "}
              {t("notesPage.due")} {formattedDueDate}
            </>
          )}
        </div>
      )}
    </div>
  );
};
